__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "google_class_webapp";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "12.2.17", function() { return function() { return __webpack_require__(/*! ./node_modules/@angular/common/__ivy_ngcc__/fesm2015/http.js */ 91841); }; }, 1);
			register("@angular/common", "12.2.17", function() { return function() { return __webpack_require__(/*! ./node_modules/@angular/common/__ivy_ngcc__/fesm2015/common.js */ 38583); }; }, 1);
			register("@angular/core", "12.2.17", function() { return function() { return __webpack_require__(/*! ./node_modules/@angular/core/__ivy_ngcc__/fesm2015/core.js */ 37716); }; }, 1);
			register("@angular/router", "12.2.17", function() { return function() { return __webpack_require__(/*! ./node_modules/@angular/router/__ivy_ngcc__/fesm2015/router.js */ 39895); }; }, 1);
			register("@lst/lst-auth", "2.1.0", function() { return function() { return __webpack_require__(/*! ./node_modules/@savvaslearning/lst-auth/fesm2015/savvaslearning-lst-auth.js */ 76902); }; }, 1);
			register("@ngx-translate/core", "13.0.0", function() { return function() { return __webpack_require__(/*! ./node_modules/@ngx-translate/core/__ivy_ngcc__/fesm2015/ngx-translate-core.js */ 29790); }; }, 1);
			register("@savvaslearning/lst-events", "1.0.2", function() { return function() { return __webpack_require__(/*! ./node_modules/@savvaslearning/lst-events/fesm2015/savvaslearning-lst-events.js */ 82799); }; }, 1);
			register("apollo-angular", "1.10.0", function() { return function() { return __webpack_require__(/*! ./node_modules/apollo-angular/__ivy_ngcc__/fesm2015/ngApollo.js */ 550); }; }, 1);
			register("apollo-client", "2.6.10", function() { return function() { return __webpack_require__(/*! ./node_modules/apollo-client/bundle.esm.js */ 21667); }; }, 1);
			register("rxjs/operators", "6.6.7", function() { return function() { return __webpack_require__(/*! ./node_modules/rxjs/_esm2015/operators/index.js */ 30397); }; }, 1);
			register("rxjs", "6.6.7", function() { return function() { return __webpack_require__(/*! ./node_modules/rxjs/_esm2015/index.js */ 765); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};